// Auswertungen der geladenen oder markierten Kontakte: E-Mail-Adressen und Nummern zum Kopieren, Zeilen für die CSV-Datei.
// Rein (mit node --test prüfbar, deshalb nur Typ-Importe).
import type { KontaktZeile } from "../api/kontakte";

export const CSV_KOPF = ["Name", "Funktion", "Lead", "Lead-Status", "Telefon", "E-Mail", "Erstellt", "Geändert"];

/** Eindeutige E-Mail-Adressen in der Reihenfolge der Liste; abgemeldete Adressen bleiben draußen. */
export function mailAdressen(zeilen: readonly KontaktZeile[]): string[] {
  const gesehen = new Set<string>();
  const ergebnis: string[] = [];
  for (const z of zeilen) {
    for (const m of z.emails) {
      const adresse = (m.email ?? "").trim();
      const schluessel = adresse.toLowerCase();
      if (!adresse || m.is_unsubscribed || gesehen.has(schluessel)) continue;
      gesehen.add(schluessel);
      ergebnis.push(adresse);
    }
  }
  return ergebnis;
}

/** Eindeutige Telefonnummern (so, wie sie gespeichert sind) in der Reihenfolge der Liste. */
export function telefonNummern(zeilen: readonly KontaktZeile[]): string[] {
  const gesehen = new Set<string>();
  const ergebnis: string[] = [];
  for (const z of zeilen) {
    for (const t of z.phones) {
      const nummer = (t.phone ?? "").trim();
      if (!nummer || gesehen.has(nummer)) continue;
      gesehen.add(nummer);
      ergebnis.push(nummer);
    }
  }
  return ergebnis;
}

function datum(iso: string | null): string {
  return iso ? iso.slice(0, 10) : "";
}

/** Kopfzeile plus eine Zeile je Kontakt; mehrere Nummern und Adressen stehen mit „; “ getrennt in einer Zelle. */
export function csvZeilen(zeilen: readonly KontaktZeile[]): string[][] {
  return [
    CSV_KOPF,
    ...zeilen.map((z) => [
      z.name ?? "",
      z.title ?? "",
      z.lead_name ?? "",
      z.lead_status_label ?? "",
      z.phones.map((t) => t.phone).filter(Boolean).join("; "),
      z.emails.map((m) => m.email).filter(Boolean).join("; "),
      datum(z.date_created),
      datum(z.date_updated),
    ]),
  ];
}
